import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
}

const defaultProps = {
  width: '13.262',
  height: '9.703',
  color: '#fedd3c',
}

function IconCheck(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.262 9.703"
      width={props.width}
    >
      <path
        className="a"
        fill={props.color}
        d="M33.239,25.364a1.114,1.114,0,0,1,0,1.576l-7.475,7.475a1.114,1.114,0,0,1-1.576,0L20.63,30.857a1.114,1.114,0,0,1,1.576-1.576l2.771,2.771,6.687-6.687A1.114,1.114,0,0,1,33.239,25.364Z"
        transform="translate(-20.304 -25.038)"
      />
    </svg>
  )
}

IconCheck.propTypes = propTypes

IconCheck.defaultProps = defaultProps

export default IconCheck
